function getDeliveryDate() {
    const daysOfWeek = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
    const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    
    // Obteniendo la fecha y hora actual en la zona horaria de México
    let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO();
    today = new Date(today);
  
    /*let today = luxon.DateTime.fromObject({ year: 2025, month: 01, day: 1, hour: 0, minute: 00 }).setZone('America/Mexico_City').toISO();;
    today = new Date(today);*/
  
    const currentHour = today.getHours();
    const currentMinutes = today.getMinutes();
    const currentDay = today.getDay(); 
  
    let deliveryDate = new Date(today);
  
    // Lunes a Jueves antes de las 1:00 PM - entrega hoy mismo
    if (currentDay >= 1 && currentDay <= 4) { 
      if (currentHour < 13 || (currentHour === 13 && currentMinutes === 0)) {
        return "hoy mismo";
      } else {
        // Lunes a Jueves después de las 1:00 PM - entrega al día siguiente
        deliveryDate.setDate(today.getDate() + 1);
      }
    }
  
    // Viernes antes de las 1:00 PM - entrega hoy mismo
    if (currentDay === 5 && (currentHour < 13 || (currentHour === 13 && currentMinutes === 0))) {
      return "hoy mismo";
    }
  
    // Viernes después de las 1:00 PM - entrega el sábado
    if (currentDay === 5 && currentHour >= 13) {
      deliveryDate.setDate(today.getDate() + 1);
    }
  
    // Sábado antes de las 10:00 AM - entrega hoy mismo
    if (currentDay === 6 && (currentHour < 10 || (currentHour === 10 && currentMinutes === 0))) {
      return "hoy mismo";
    }
  
    // Sábado después de las 10:00 AM o Domingo en cualquier momento - entrega el lunes
    if ((currentDay === 6 && currentHour >= 10) || currentDay === 0) {
      const daysUntilMonday = currentDay === 6 ? 2 : 1;
      deliveryDate.setDate(today.getDate() + daysUntilMonday);
    }
  
    const dayName = daysOfWeek[deliveryDate.getDay()];
    const monthName = monthsOfYear[deliveryDate.getMonth()];
    const day = deliveryDate.getDate();
  
    return `${dayName}, ${day} de ${monthName}`;
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const dateElement = document.getElementById('date__estimated');
    if (dateElement) {
      let date = getDeliveryDate();
      dateElement.textContent = date;
    }
  });
  